<template>
  <div class="nav-item send-prayer">
    <router-link to="/dua" class="nav-link">
      🤲 {{ $t("menu.sendPrayer") }}
    </router-link>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({});
</script>

<style scoped>
.send-prayer {
  @apply border border-[#FFA722] border-solid rounded-full text-center overflow-hidden;
  a {
    @apply opacity-100 text-[14px];
    font-weight: 600;
    @apply block p-3 px-4 rounded-full;
    @apply text-[14px] leading-[21px] text-white md:text-black lg:opacity-100 lg:text-[#222222];
    &:hover {
      @apply bg-[#FFA722] lg:bg-transparent opacity-100;
    }
  }
}
</style>
